/* Playback animations for the Learn Phoebe fake chat: each revealed turn
   eases in, and the composer caret blinks while the ask is typed out. */

@keyframes learn-phoebe-turn-in {
    from {
        opacity: 0;
        transform: translateY(6px);
    }
    to {
        opacity: 1;
        transform: translateY(0);
    }
}

@keyframes learn-phoebe-caret-blink {
    0%,
    50% {
        opacity: 1;
    }
    50.01%,
    100% {
        opacity: 0;
    }
}

@media (prefers-reduced-motion: no-preference) {
    .learn-phoebe-turn-in {
        animation: learn-phoebe-turn-in 240ms ease-out both;
    }

    .learn-phoebe-caret {
        animation: learn-phoebe-caret-blink 1.1s steps(1) infinite;
    }
}
